function isYummie() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('yummie') !== -1;
}

export default isYummie;
